import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BreadcrumbState {
  data: Record<string, string>;
}

const initialState: BreadcrumbState = {
  data: {}
};

const breadcrumb = createSlice({
  name: 'breadcrumb',
  initialState,
  reducers: {
    setBreadcrumbData(state, action: PayloadAction<Record<string, string>>) {
      state.data = { ...state.data, ...action.payload };
    },
    clearBreadcrumbData(state) {
      state.data = {};
    }
  }
});

export default breadcrumb.reducer;

export const { setBreadcrumbData, clearBreadcrumbData } = breadcrumb.actions;
